import { useCallback } from 'react';
const useCallbackByKey = (effect, deps) => {
  return useCallback(effect, deps);
};
export default useCallbackByKey;